(function () {
  'use strict';

  const ATC_SELECTOR = '[data-knn-search-atc]';
  const CARD_SELECTOR = '[data-knn-search-card]';
  const PURCHASE_SELECTOR =
    '[data-knn-search-purchase]:checked';

  /**
   * Adds a search-card product to Shopify.
   *
   * After Shopify confirms the mutation, the existing KNN mini-cart
   * is notified through the same event used by the homepage cards.
   *
   * KNN mini-cart owns:
   * - cart content refresh
   * - cart popup opening
   * - header cart bubble synchronization
   *
   * @param {HTMLButtonElement} button
   * @param {HTMLElement} card
   * @param {HTMLInputElement} selectedOption
   */
  async function addSearchProductToCart(
    button,
    card,
    selectedOption
  ) {
    const variantId = parseInt(
      selectedOption.dataset.variantId,
      10
    );

    const sellingPlanId = parseInt(
      selectedOption.dataset.sellingPlanId,
      10
    );

    if (!variantId) {
      console.warn(
        '[knn-search-atc] Missing variant ID.'
      );
      return;
    }

    const addText =
      button.dataset.addText ||
      button.textContent ||
      'Add to cart';

    const loadingText =
      button.dataset.loadingText ||
      'Adding...';

    const item = {
      id: variantId,
      quantity: 1
    };

    /*
     * Subscription.
     *
     * Keep the selling plan only for Subscribe & Save.
     */
    if (
      selectedOption.value === 'subscribe' &&
      sellingPlanId
    ) {
      item.selling_plan = sellingPlanId;
    }

    button.disabled = true;
    button.textContent = loadingText;

    try {
      const response = await fetch(
        '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            Accept:
              'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [item]
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Could not add item to cart.'
        );
      }

      /*
       * IMPORTANT:
       *
       * Use the SAME cart synchronization flow already used
       * by knn-product-card on the homepage.
       *
       * The KNN mini-cart will fetch the latest cart state,
       * update its contents, open itself and synchronize
       * the header bubble.
       */
      document.dispatchEvent(
        new CustomEvent(
          'knn:cart:added',
          {
            bubbles: true,
            detail: {
              source: 'knn-search',
              variantId: variantId,
              sellingPlanId:
                selectedOption.value === 'subscribe'
                  ? sellingPlanId || null
                  : null,
              purchaseType:
                selectedOption.value,
              productId:
                card.dataset.productId || null
            }
          }
        )
      );

      button.textContent = 'Added';

      window.setTimeout(function () {
        if (button.isConnected) {
          button.textContent = addText;
        }
      }, 1400);
    } catch (error) {
      console.error(
        '[knn-search-atc]',
        error
      );

      if (button.isConnected) {
        button.textContent = addText;
      }

      window.alert(
        error?.message ||
        'Could not add item to cart.'
      );
    } finally {
      if (button.isConnected) {
        button.disabled = false;
      }
    }
  }

  /**
   * Delegated ATC handler.
   *
   * Delegation is required because predictive search cards
   * are dynamically replaced by morph().
   */
  document.addEventListener(
    'click',
    function (event) {
      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      const button =
        target.closest(ATC_SELECTOR);

      if (
        !(button instanceof HTMLButtonElement)
      ) {
        return;
      }

      const card =
        button.closest(CARD_SELECTOR);

      if (!(card instanceof HTMLElement)) {
        return;
      }

      const selectedOption =
        card.querySelector(
          PURCHASE_SELECTOR
        );

      if (
        !(
          selectedOption instanceof
          HTMLInputElement
        )
      ) {
        return;
      }

      addSearchProductToCart(
        button,
        card,
        selectedOption
      );
    }
  );
})();